import React from 'react';
import PropTypes from 'prop-types';
import { ActionIconCheckmark } from '@klarna/bubble-ui';

const styles = (isChecked, isDisabled) => ({
  width: 30,
  height: 30,
  borderRadius: 15,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...(isChecked
    ? {
        backgroundColor: '#487B94',
        border: undefined,
      }
    : {}),
  ...(isDisabled
    ? {
        backgroundColor: '#BBB8B5',
      }
    : {}),
  ...(!isChecked && !isDisabled
    ? {
        backgroundColor: 'white',
        border: '1px solid #979493',
      }
    : {}),
});

const CheckMarkRound = ({ isChecked = false, disabled = false }) => (
  <div style={styles(isChecked, disabled)}>
    {isChecked && <ActionIconCheckmark colorToken="colors/text/inverse" />}
  </div>
);

CheckMarkRound.propTypes = {
  disabled: PropTypes.bool,
  isChecked: PropTypes.bool,
};

export default CheckMarkRound;
